import { InjectableClass } from '@fino/lib-injection';

export class FaqService extends InjectableClass {
  constructor($http, faqUrls, appConfig, configService) {
    'ngInject';
    super({ $http, faqUrls, appConfig, configService });
  }

  getFaq() {
    const stage = this.configService.getStage() || 'dev';
    const { config } = this.appConfig;
    const tenantName = config.tenant.name;
    const themeName = config.theme.name;
    return this.$http({
      method: 'GET',
      url: `${this.faqUrls[stage]}/faq?project=dws&tenant=${tenantName}&theme=${themeName}&escape=false`,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ui/faq/faq.service.js